import Resource from '@/api/resource'
import request from '@/utils/request'

class Chatbot extends Resource {
  constructor() {
    super('chatbot')
  }

  list(query) {
    return request({
      url: 'ai-session/index',
      method: 'POST',
      data: query,
    })
  }

  remove(id) {
    return request({
      url: `/${this.uri}/${id}`,
      method: 'delete',
      headers: { 'Content-Type': 'application/json' },
    })
  }

  store(query) {
    return request({
      url: `/${this.uri}/store`,
      method: 'post',
      data: query,
    })
  }

  put(query) {
    return request({
      url: `/${this.uri}/store`,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: query,
    })
  }

  update(query) {
    return request({
      url: `/${this.uri}/update/${query.id}`,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: query.query,
    })
  }

  get(id) {
    return request({
      url: `/ai-session/show/${id}`,
      method: 'get',
    })
  }

  students(institution_id) {
    return request({
      url: '/students/index',
      method: 'post',
      data: institution_id,
    })
  }

  lookups() {
    return request({
      url: `${this.uri}/lookups`,
      method: 'get',
    })
  }
}

export { Chatbot as default }
